// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** Authenticator codes: forms submit by themselves once all six digits are in. */

/** The digits typed, spaces taken out ("123 456" → "123456"). */
export const otpDigits = (text: string): string => text.replace(/\s/g, "");

/** True when the text is a whole six-digit code. */
export const isFullOtp = (text: string): boolean => /^\d{6}$/.test(otpDigits(text));
